import { createWebHistory, createRouter } from "vue-router";

import AddWithdrawalMethod from "@/pages/dashboard/withdrawal/AddWithdrawalMethod"
import AddWithdrawalRequest from "@/pages/dashboard/withdrawal/AddWithdrawalRequest"
import AuthMain from "@/pages/auth/AuthMain";
import DashboardMain from '@/pages/dashboard/DashboardMain.vue'
import ForgetPassword from '@/pages/auth/ForgetPassword'
import Login from '@/pages/auth/Login'
import SendOtp from "@/pages/auth/otp/SendOtp";
import SetPasscode from "@/pages/auth/passcode/SetPasscode"
import SignUp from '@/pages/auth/SignUp'
import VerifyOtp from "@/pages/auth/otp/VerifyOtp"
import PasscodeLogin from "@/pages/auth/passcode/PasscodeLogin";
import Stats from "@/pages/dashboard/stats/Stats";
import PaymentLink from "@/pages/dashboard/payment-link/PaymentLink";
import AddPaymentLink from "@/pages/dashboard/payment-link/AddPaymentLink";
import Withdrawal from "@/pages/dashboard/withdrawal/Withdrawal";
import VerifyEmailPhone from "@/pages/dashboard/send-money/VerifyEmailPhone";
import InitiateSendMoney from "@/pages/dashboard/send-money/InitiateSendMoney"
import ConfirmSendMoney from "@/pages/dashboard/send-money/ConfirmSendMoney"
import GetMoneyRequests from "@/pages/dashboard/request-money/GetMoneyRequests"
import InitiateMoneyRequest from "@/pages/dashboard/request-money/InitiateMoneyRequest"
import DepositMoneyMain from "@/pages/dashboard/deposit-money/DepositMoneyMain"
import InitiateDepositMoney from "@/pages/dashboard/deposit-money/InitiateDepositMoney"
import Transaction from "@/pages/dashboard/transaction/Transaction"
import Refund from "@/pages/dashboard/refund/Refund";
import CreateRefund from "@/pages/dashboard/refund/CreateRefund";
import InitiateUserRequestSendMoney from "@/pages/dashboard/request-money/send-money/InitiateUserRequestSendMoney";
import ConfirmUserRequestSendMoney from "@/pages/dashboard/request-money/send-money/ConfirmUserRequestSendMoney";
import Profile from "@/pages/dashboard/profile/Profile";
import AppSetting from "@/pages/dashboard/app-settings/AppSetting";
import Staff from "@/pages/dashboard/staff/Staff"
import StaffPermission from "@/pages/dashboard/staff/StaffPermission"
import AddStaff from "@/pages/dashboard/staff/AddStaff"
import UpdateStaff from "@/pages/dashboard/staff/UpdateStaff"
import TransactionDetailPage from "@/pages/dashboard/transaction/TransactionDetailPage";
import TransactionAttempt from "@/pages/dashboard/transaction/TransactionAttempt";
import PaymentLinkView from "@/pages/dashboard/payment-link/PaymentLinkView";
import AccountLedger from "@/pages/dashboard/account-ledger/AccountLedger"
import ApiPayment from "@/pages/dashboard/api-payment/ApiPayment"
import Customer from "@/pages/dashboard/customer/Customer"
import BalanceOnHold from '@/pages/dashboard/balance-onHold/BalanceOnHold'
import UserInputForm from "@/pages/auth/UserInputForm";
import TransactionReport from "@/pages/dashboard/reports/TransactionReport";
import VolumeReports from "@/pages/dashboard/reports/VolumeReports";
import VerifyEmailGeneral from "@/pages/auth/VerifyEmailGeneral"
import ResetPassword from "@/pages/auth/ResetPassword"
import ResetPin from "@/pages/auth/ResetPin"
import AllNotification from "@/pages/dashboard/Notifications/AllNotification"
import AggregateSettlement from "@/pages/dashboard/settlement/AggregateSettlement";
import DirectSettlement from '@/pages/dashboard/settlement/DirectSettlement'
import AggregateSettlementDetail from "@/pages/dashboard/settlement/AggregateSettlementDetail";
import DirectSettlementDetail from "@/pages/dashboard/settlement/DirectSettlementDetail";
import PaymentLinkAttempListing from "@/pages/dashboard/payment-link/PaymentLinkAttempListing";
import PaymentLinkAttempLogs from "@/pages/dashboard/payment-link/PaymentLinkAttempLogs";
import TransactionDetialPageWithId from "@/pages/dashboard/transaction/TransactionDetialPageWithId";
import AllSettlement from "@/pages/dashboard/settlement/AllSettlement";
import Pos from "@/pages/dashboard/pos/Pos.vue";
import AddPos from "@/pages/dashboard/pos/AddPos.vue";
import UpdatePos from "@/pages/dashboard/pos/UpdatePos.vue";
import PosAssignStaff from "@/pages/dashboard/pos/PosAssignStaff.vue";
import Store from "@/pages/dashboard/store/Store.vue";
import AddStore from "@/pages/dashboard/store/AddStore.vue";
import UpdateStore from "@/pages/dashboard/store/UpdateStore.vue";
import StoreAccountActivation from "@/pages/dashboard/store/account-activation/StoreAccountActivation.vue";
import UpdateStoreAccountActivation from "@/pages/dashboard/store/account-activation/UpdateStoreAccountActivation.vue";
import ApiKeys from "@/pages/dashboard/api-keys/ApiKeys.vue";

const routes = [
    {
        name: 'auth',
        path: '/auth/',
        component: AuthMain,
        children: [
            {
                name: 'send-otp',
                path: 'verify',
                component: SendOtp
            },
            {
                name: 'send-otp-alternalte',
                path: 'send-otp',
                component: SendOtp
            },
            {
                name: 'verify-otp',
                path: 'verify-otp',
                component: VerifyOtp
            },
            {
                name: 'signup',
                path: 'signup',
                component: SignUp
            },
            {
                name: 'login',
                path: 'login',
                component: Login
            },
            {
                name: 'forget-password',
                path: 'forget-password',
                component: ForgetPassword
            },
            {
                name: 'set-passcode',
                path: 'set-passcode',
                component: SetPasscode
            },
            {
                name: 'passcode-login',
                path: 'passcode-login',
                component: PasscodeLogin
            },
            {
                name: 'user-input',
                path: 'user-input',
                component: UserInputForm
            },
            {
                name: 'verify-email-general',
                path: 'verify-email-general',
                component: VerifyEmailGeneral
            },
            {
                name: 'reset-password',
                path: 'reset-password',
                component: ResetPassword
            },
            {
                name: 'reset-pin',
                path: 'reset-pin',
                component: ResetPin
            },
        ]
    },
    {
        name: 'dashboard',
        path: '/app',
        component: DashboardMain,
        children: [
            {
                name: 'dashboard-overview',
                path: '/app',
                component: Stats,
            },
            {
                name: 'payment-link',
                path: 'payment-link',
                component: PaymentLink,
            },
            {
                name: 'payment-link-add',
                path: 'payment-link/add',
                component: AddPaymentLink,
            },
            {
                name: 'payment-link-view',
                path: 'payment-link/view',
                component: PaymentLinkView,
            },
            {
                name: 'payment-link-attempt',
                path: 'payment-link/attempt/:id',
                component: PaymentLinkAttempListing,
            },
            {
                name: 'payment-link-attempt-detail',
                path: 'payment-link/attempt/:id/detail',
                component: PaymentLinkAttempLogs,
            },
            {
                name: 'api-payment',
                path: 'api-payment',
                component: ApiPayment,
            },
            {
                name: 'merchant-customers',
                path: 'merchant-customers',
                component: Customer,
            },
            {
                name: 'account-ledger',
                path: 'account-ledger',
                component: AccountLedger,
            },
            {
                name: 'refund-request',
                path: 'refund',
                component: Refund,
            },
            {
                name: 'refund-create',
                path: 'refund/create',
                component: CreateRefund,
            },
            {
                name: 'transactions',
                path: 'my-transactions',
                component: Transaction,
                props: true,
            },
            {
                name: 'transactions-details',
                path: 'transactions/details',
                component: TransactionDetailPage,
            },
            {
                name: 'transactions-details-with-id',
                path: 'transactions/details/:id',
                component: TransactionDetialPageWithId,
                props: true,
            },
            {
                name: 'transactions-attempt',
                path: 'transactions/attempts/:uuid',
                props: true,
                component: TransactionAttempt,
            },
            {
                name: 'app-setting',
                path: 'app-setting',
                component: AppSetting,
            },
            {
                name: 'merchant-staff',
                path: 'merchant-staff',
                component: Staff,
            },
            {
                name: 'merchant-staff-add',
                path: 'merchant-staff/add',
                component: AddStaff,
            },
            {
                name: 'merchant-staff-update',
                path: 'merchant-staff/update',
                component: UpdateStaff,
            },
            {
                name: 'merchant-staff-permission',
                path: 'merchant-staff/permission',
                component: StaffPermission,
            },
            {
                name: 'pos-devices',
                path: 'pos-devices',
                component: Pos,
            },
            {
                name: 'pos-add',
                path: 'pos/add',
                component: AddPos,
            },
            {
                name: 'pos-update',
                path: 'pos/update',
                component: UpdatePos,
            },
            {
                name: 'store',
                path: 'store',
                component: Store,
            },
            {
                name: 'store-add',
                path: 'store/add',
                component: AddStore,
            },
            {
                name: 'store-update',
                path: 'store/update',
                component: UpdateStore,
            },
            {
                name: 'account-activation',
                path: 'store/account-activation/:uniqueRef/:parentEntity',
                component: StoreAccountActivation,
            },
            {
                name: 'update-account-activation',
                path: 'store/update/account-activation',
                component: UpdateStoreAccountActivation,
            },
            {
                name: 'pos-assign-staff',
                path: 'pos/assign-staff/:id',
                component: PosAssignStaff,
            },
            {
                name: 'hold-balance',
                path: 'hold-balance',
                component: BalanceOnHold,
            },
            {
                name: 'profile',
                path: 'profile',
                component: Profile,
            },
            {
                name: 'report',
                path: 'reports/transaction',
                component: TransactionReport,
            },
            {
                name: 'volume-reports',
                path: 'volume-reports',
                component: VolumeReports,
            },
            {
                name: 'all-notification',
                path: 'all-notification',
                component: AllNotification,
            },
            {
                name: 'settlements',
                path: 'settlements',
                props: true,
                component: AllSettlement,
            },
            {
                name: 'agregate-settlement',
                path: 'agregate-settlement',
                component: AggregateSettlement,
            },
            {
                name: 'direct-settlement',
                path: 'direct-settlement',
                component: DirectSettlement,
            },
            {
                name: 'agregate-settlement-detail',
                props: true,
                path: 'agregate-settlement/detail/:id',
                component: AggregateSettlementDetail,
            },
            {
                name: 'direct-settlement-detail',
                props: true,
                path: 'direct-settlement/detail/:id',
                component: DirectSettlementDetail,
            },
            {
                name: 'merchant-app-settings',
                path: 'merchant-app-settings',
                component: ApiKeys,
            },

        ]
    },

]

const router = createRouter({
    history: createWebHistory(),
    routes // short for `routes: routes`
});


export default router;
